/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Partner_Admin_Commission_Quarter_ApproveInputs */



/**
* | output |
* | --- |
* | "Approve quarter ({amount})" |
*
* @param {Partner_Admin_Commission_Quarter_ApproveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_quarter_approve = /** @type {((inputs: Partner_Admin_Commission_Quarter_ApproveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Quarter_ApproveInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Quartal freigeben (${i?.amount})`)
	return /** @type {LocalizedString} */ (`Approve quarter (${i?.amount})`)
});